import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

import { comModoSlim, PARAM_SLIM } from '@/lib/slim';

import { buscaDoProtocolo } from './entradaDoProtocolo';

/**
 * A rota antiga da tela de peticionar, aposentada (docs/PLANO_BANCADA.md, Bloco 4):
 * ficou só como redirecionamento, para não quebrar link salvo, favorito, e-mail já
 * enviado nem aba aberta. Leva aos autos com o editor e a barra do protocolo. O
 * rascunho do link (`draft`) vai para a barra e o modelo do "Usar modelo" (que
 * vinha por navigation state) vai ao editor; a instância pedida no link sai — o
 * rascunho já diz a dele, e sem rascunho vale a dos autos. O modo janela
 * (`slim`) é preservado.
 */
export default function RedirecionarPeticionar() {
  const { numero = '' } = useParams<{ numero: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const modelo = (location.state as { modeloId?: string } | null)?.modeloId ?? null;
  const base = `/app/processos/${encodeURIComponent(numero)}/autos`;
  const busca = buscaDoProtocolo({ rascunho: searchParams.get('draft'), modelo });
  const destino = searchParams.get(PARAM_SLIM) ? comModoSlim(base, busca) : `${base}${busca}`;
  return <Navigate replace to={destino} />;
}
